import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { UserAuthService } from '../services/user-auth.service';
import { B2cConfigService } from '../services/b2c-config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly cookieService: CookieService,
    private readonly userAuthService: UserAuthService,
    private readonly b2cConfig: B2cConfigService
  ) { }

  totalRequests = 0;
  completedRequests = 0;
  isBranchUrlUser: boolean = false;
  private samlSpinnerHideTimeout: any;

  private isIdentityHost(url: string): boolean {
    try {
      const requestHost = new URL(url).hostname;
      return this.b2cConfig.identityHosts().includes(requestHost);
    } catch {
      return false;
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.totalRequests++;
    const excludeShowLoader = ['chat/save','userbudget/saveuserbudget', 'userwealth/savewealthscore', environment.azureAdConfig.b2cDomain,
      'sapi/fetcheventfromsapi'
    ];
    let showLoader = true;
    for (const item of excludeShowLoader) {
      if (request.url.toLowerCase().includes(item)) {
        showLoader = false;
      }
    }

    if (showLoader) {
      this.spinner.show();

      if (this.userAuthService.isSamlUser() && this.samlSpinnerHideTimeout) {
        clearTimeout(this.samlSpinnerHideTimeout);
        this.samlSpinnerHideTimeout = undefined;
      }
    }
    

    if (this.userAuthService.isSamlUser()) {
      if (this.isIdentityHost(request.url)) {
        return next.handle(request);
      }
      request = request.clone({
        headers: this.addExtraHeaders(request.headers)
      });
    } else if (!this.isIdentityHost(request.url)) {
        request = request.clone({
          headers: this.addExtraHeaders(request.headers)
        });
      }

    return next.handle(request).pipe(
      catchError(
        err =>
          new Observable<HttpEvent<any>>(observer => {
            if (err instanceof HttpErrorResponse) {
              const errResp = err ;
              if (errResp.status === 401 || errResp.status === 0) {
                this.cookieService.delete('submissionId', '/');
                this.cookieService.delete('userId','/');
                this.userAuthService.logOut();
              }
            }
            observer.error(err);
            observer.complete();
          })
      )
    ).pipe(
      finalize(() => {
        this.completedRequests++;
        if (this.userAuthService.isSamlUser()) {
          if (this.samlSpinnerHideTimeout) {
            clearTimeout(this.samlSpinnerHideTimeout);
          }
          this.samlSpinnerHideTimeout = setTimeout(() => {
            this.spinner.hide();
            this.samlSpinnerHideTimeout = undefined;
          }, 5000);
        } else if (this.completedRequests === this.totalRequests) {
            this.spinner.hide();
            this.completedRequests = 0;
            this.totalRequests = 0;
          
        }
      })
    );
    
  }

  private addExtraHeaders(headers: HttpHeaders): HttpHeaders {
    let submissionId = '';
    let branchUTMParams = sessionStorage.getItem('branchUTMParams') || '';
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    headers = headers.append('SubmissionId', submissionId);
    headers = headers.append('Cache-Control', 'no-cache');
    headers = headers.append('Pragma', 'no-cache');
    headers = headers.append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
    headers = headers.append('Version', 'V1');
    if (branchUTMParams) this.isBranchUrlUser = true;
    headers = headers.append('isBranchUrlUser', String(this.isBranchUrlUser));
    
    if (this.userAuthService.isSamlUser()) {
      headers = headers.append('Authorization', `Bearer ${this.userAuthService.getAccessToken()}`);
    } else if (localStorage.getItem('tempToken')) {
      if(!headers.get('Authorization'))
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('tempToken')}`);
    }
    return headers;
  }
}
